import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

const collapseElem = () => {
  const $collapse = $('.c-collapse');
  const $scroll = $('html, body');
  if ($collapse && $collapse.length) {
    $collapse.on('shown.bs.collapse', ev => {
      $scroll.animate({
        scrollTop:
          $(ev.target)
            .parent()
            .position().top - 100,
      });
    });
  }
};
export default collapseElem;



// WEBPACK FOOTER //
// ./src/scripts/modules/collapse.js